import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';

import { Branding } from '../../branding';

import TabMfaData from '../Settings/tabMfaData';

function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div role="tabpanel" hidden={value !== index} id={`usedata-tabpanel-${index}`} aria-labelledby={`userdata-tab-${index}`} {...other}>
			{value === index && (
				<Box p={3}>
					<Typography component={'div'}>{children}</Typography>
				</Box>
			)}
		</div>
	);
}

TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.any.isRequired,
	value: PropTypes.any.isRequired,
};

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
	},
	grid: {
		justifyContent: 'center',
	},
	box: {
		width: '90%',
		maxWidth: 650,
	},
	appBar: {
		backgroundColor: Branding.white,
	},
	tabs: {
		color: Branding.primary,
		indicator: Branding.accent,
	},
	tabsIndicator: {
		background: Branding.accent,
	},
	tabPanelBox: {
		display: 'flex',
		justifyContent: 'center',
	},
}));

export default function Content(props) {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<CssBaseline />
			<Grid container className={classes.grid}>
				<Box className={classes.tabPanelBox}>
					<TabMfaData />
				</Box>
			</Grid>
		</div>
	);
}
